/* Join page: flip tiles on tap, copy code, scroll reveal + count-up, phone sticky button. */
(function () {
  var root = document.querySelector('.j9');
  if (!root) return;
  root.querySelectorAll('.j9-perk').forEach(function (b) { b.addEventListener('click', function () { b.classList.toggle('on'); }); });
  root.addEventListener('click', function (e) {
    var c = e.target.closest('[data-j9-copy]');
    if (c) { if (navigator.clipboard) navigator.clipboard.writeText(c.dataset.j9Copy); c.textContent = 'Copied'; }
  });
  var count = function (n) {
    var to = +n.dataset.n, t0 = performance.now(), plus = to >= 1000 ? '+' : '';
    var f = function (now) { var p = Math.min(1, (now - t0) / 1200); n.textContent = Math.round(to * (1 - Math.pow(1 - p, 3))).toLocaleString() + (p === 1 ? plus : ''); if (p < 1) requestAnimationFrame(f); };
    requestAnimationFrame(f);
  };
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (!e.isIntersecting) return; e.target.classList.add('in'); io.unobserve(e.target); e.target.querySelectorAll('[data-n]').forEach(count); });
    }, { threshold: 0.15 });
    root.querySelectorAll('.j9-rv').forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 0.08 + 's'; io.observe(el); });
    var st = root.querySelector('.j9-sticky'), box = document.getElementById('j9-box');
    // sticky button only between the form and the final band
    var fin = root.querySelector('.j9-final'), past = false, atEnd = false;
    var upd = function () { st.classList.toggle('on', past && !atEnd); };
    if (st && box) new IntersectionObserver(function (es) { var e = es[0]; past = !e.isIntersecting && e.boundingClientRect.top < 0; upd(); }).observe(box);
    if (st && fin) new IntersectionObserver(function (es) { var e = es[0]; atEnd = e.isIntersecting || e.boundingClientRect.top < 0; upd(); }).observe(fin);
  } else root.querySelectorAll('.j9-rv').forEach(function (el) { el.classList.add('in'); });
  // after a successful join Shopify reloads at #j9-form; bring the code into view
  if (root.querySelector('.j9-done') && document.getElementById('j9-box')) document.getElementById('j9-box').scrollIntoView({ block: 'center' });
})();
